import { ADD_PROXY, DELETE_PROXY, GET_PROXY, UPDATE_PROXY } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getProxy = (payload) => {
  return apiInstance.post(GET_PROXY, payload);
};

export const addProxy = (payload) => {
  return apiInstance.post(ADD_PROXY, payload);
};

export const editProxy = (payload) => {
  return apiInstance.post(UPDATE_PROXY, payload);
};

export const deleteProxy = (payload) => {
  return apiInstance.post(DELETE_PROXY, payload);
};
